import { useMemo } from 'react';
import useOnVisible from './useOnVisible';

const useLazyLoadedURL = (
  elementRef: React.MutableRefObject<HTMLElement>,
  url: string,
  threshold = 0.5,
  delayTimeInMilliseconds?: number
): string | undefined => {
  const isVisible = useOnVisible(elementRef, threshold, delayTimeInMilliseconds);
  const sourceURL = useMemo(() => (!isVisible ? undefined : url), [url, isVisible]);

  return sourceURL;
};

export default useLazyLoadedURL;
